<template>
    <div class="jgile-slider">
        <div class="range">
            <a @click.prevent="incrementDown" class="minus" href="#">
                <i class="fal fa-minus"></i>
            </a>
            <input :max="max" :min="min" :value="value" @input="changeValue" class="form-control-range" type="range" />
            <a @click.prevent="incrementUp" class="plus" href="#">
                <i class="fal fa-plus"></i>
            </a>
        </div>
        <div class="row">
            <div class="col-6 offset-3">
                <div class="input-group">
                    <input :max="max" :min="min" :value="value" @input="changeValue" class="form-control" type="number" />
                    <div class="input-group-append">
                        <div class="input-group-text">%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: 0,
            required: true,
            type: Number,
        },
        min: {
            type: Number,
            default: -100,
        },
        max: {
            type: Number,
            default: 100,
        },
        incrementBy: {
            default: 10,
            type: Number,
        },
    },
    methods: {
        incrementUp() {
            let num = _.toNumber(this.value) + this.incrementBy;
            num = num > this.max ? this.max : num;
            num = num < this.min ? this.min : num;

            this.emitValue(Math.floor(num / this.incrementBy) * this.incrementBy);
        },
        incrementDown() {
            let num = _.toNumber(this.value) - this.incrementBy;
            num = num > this.max ? this.max : num;
            num = num < this.min ? this.min : num;

            this.emitValue(Math.floor(num / this.incrementBy) * this.incrementBy);
        },
        changeValue(event) {
            this.emitValue(event.target.value);
        },
        emitValue(val) {
            this.$emit('input', parseInt(val));
        },
    },
};
</script>
